import { makeStyles, shorthands, makeStaticStyles, tokens } from '@fluentui/react-components';

export const usePerformancePageStaticStyles = makeStaticStyles({
  '.k-animation-container .k-header a[role="button"]:focus': {
    ...shorthands.outline('1px', 'solid', tokens.colorStrokeFocus2),
  },
});

export const usePerformancePageStyles = makeStyles({
  assetLibraryPerformancePageContainer: {
    ...shorthands.padding('0', '25px'),

    '& .asset-library-search': {
      width: '300px',
    },

    '& .asset-library-performance-grid-container': {
      '& .navbar .container-fluid': {
        paddingLeft: '0',
        paddingRight: '0',
      },
      '& .campaign-details-list-header': {
        ...shorthands.overflow('hidden'),
      },
    },

    '& .highlighted-text': {
      // backgroundColor: palette.yellowLight,
    },

    '& .inline-download-form__email-and-schedule-report a:focus::after': {
      ...shorthands.margin('4px'),
    },
  },
  subMenu: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#ffffff',
    ...shorthands.padding('16px', '0px'),
  },
  title: {
    fontSize: '26px',
    fontWeight: '800',
    flexGrow: '1',
  },
  inlineDownloadContainer: {},
});

export const usePerfTableStyle = makeStyles({
  imagePreviewContainer: {
    width: '120px',
    height: '90px',
  },
  imagePreviewAndNameContainer: {
    '& .action-buttons-container': {
      display: 'flex',
      opacity: '0',
      ...shorthands.transition('opacity', '.3s', '.1s'),
      justifyContent: 'space-around',
      position: 'absolute',
      top: '60px',
      left: '24px',
      right: '24px',
    },
    '&:hover .action-buttons-container': {
      display: 'flex',
      opacity: '1',
    },
  },
});

export const useImagePreviewRawStyles = makeStyles({
  hostStyles: {
    display: 'inline-block',
  },
  actionButtonStyles: {
    ...shorthands.borderRadius('50%'),
    backgroundColor: '#ffffff',
    '&:hover': {
      color: '#ffffff',
      backgroundColor: '#106ebe',
    },
  },
});

export const usePerfPageToolbarStyle = makeStyles({
  toolbarFilterContainer: {
    flex: '1 !important',
    ...shorthands.padding('hidden'),

    '& .filter-list': {
      paddingTop: '10px',
      '& .asset-library-search': {
        display: 'inline-block',
        position: 'relative',
        top: '2px',
      },
    },

    '& .filter-list-editing': {
      '& .dropdown-filter-container': {
        display: 'inline-block',
        paddingTop: '12px',
      },

      '& .asset-library-search': {
        display: 'inline-block',
        paddingTop: '12px',
      },

      '& .top-rated-performance-filter': {
        alignSelf: 'center',
      },
    },
  },
});
